import React from "react"
import BackgroundLines from "../components/BackgroundLines"
import Header from "../components/Header"

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="mi-wrapper">
      <BackgroundLines />
      <Header />
      {children}
    </div>
  )
}

export default Layout
